import React from 'react';
import axios from 'axios';
import apifunctions from '../../api/functions';
import auth from '../../auth/auth.js';
import fileDownload from 'js-file-download';
import { Button } from 'reactstrap';

const exportFile = (url, fileName) => {

  let header = auth.header();
  header.responseType = "blob";

  let urlGenerated = apifunctions.generateUrl(url, null, null)

  axios.get(
    urlGenerated, header
  ).then(
    response => {
      if (response.status == 200) {
        fileDownload(response.data, fileName)
      } else {
        // console.log(reponse)
      }
    })
  // .catch(error =>  onGotErrorBlob(error, setErrors))
}

const ButtonExport = ({ url, fileName }) =>  {
 
  let header = auth.header();

  let respuesta = header.headers['Public-Token'];

  return (
    <Button
      className={(respuesta === 'df39e42d582a1e8e3982df1b2c7e89e0' || url.includes('/export/')) ? 'icon btn-sm h-100 rounded tiny-btn' : 'd-none'}
      color={'success'}
      onClick={() => exportFile(url, fileName)}
    >
      <i class="fa fa-download fa-lg" />
      {console.log(respuesta)}
    </Button>
  )
}

export default ButtonExport;


// WEBPACK FOOTER //
// ./src/views/ConsultadorArticulos/ButtonExport.js